import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import PaymentAndBillingFigure from "../../../../assets/images/payments/payment-and-billing-img.png";
import { colors } from "../../../../theme/palette";

const PaymentAndBillingSectionListStyle = {
  color: "#475467",
  fontFamily: "Montserrat",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  listStyle: "inside",
};

const PaymentAndBilling = () => {
  const { t } = useTranslation();

  const sectionList = [
    {
      title: t("pages.payment.overview.v2.createLinkTitle"),
      list: [
        t("pages.payment.overview.v2.createLinkListItem1"),
        t("pages.payment.overview.v2.createLinkListItem2"),
        t("pages.payment.overview.v2.createLinkListItem3"),
      ],
    },
    {
      title: t("pages.payment.overview.v2.managePaymentsTitle"),
      list: [
        t("pages.payment.overview.v2.managePaymentsListItem1"),
        t("pages.payment.overview.v2.managePaymentsListItem2"),
        t("pages.payment.overview.v2.managePaymentsListItem3"),
      ],
    },
    {
      title: t("pages.payment.overview.v2.getPaidTitle"),
      list: [
        t("pages.payment.overview.v2.getPaidListItem1"),
        t("pages.payment.overview.v2.getPaidListItem2"),
        t("pages.payment.overview.v2.getPaidListItem3"),
      ],
    },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", rowGap: "24px" }}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {/* <Typography
          component="p"
          sx={{
            color: "#475467",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "20px",
            maxWidth: "430px",
          }}
        >
          {t("pages.payment.overview.getPaidQuickly")}
        </Typography> */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <Typography
            component="p"
            sx={{
              color: "#475467",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "20px",
              maxWidth: "430px",
            }}
          >
            {t("pages.payment.overview.v2.createAndShare")}
          </Typography>
          <Typography
            component="p"
            sx={{
              color: "#475467",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "20px",
              maxWidth: "430px",
            }}
          >
            {t("pages.payment.overview.v2.fundsAreSafe")}
          </Typography>
        </Box>
        <img src={PaymentAndBillingFigure} width="272.345px" height="193.677px" />
      </Box>
      <Box sx={{ display: "flex", columnGap: "24px" }}>
        {sectionList.map(({ title, list }, idx) => (
          <Box sx={{ display: "flex", flexDirection: "column", rowGaGp: "12px", width: "calc(33% - 12px)" }}>
            <Typography
              component="span"
              sx={{
                color: colors.Green100,
                leadingTrim: "both",
                textEdge: "cap",
                fontFamily: "Crimson Pro",
                fontSize: "44.458px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "59.278px",
              }}
            >
              {`0${idx + 1}`}
            </Typography>
            <Typography
              component="span"
              sx={{
                color: "#101828",
                fontFamily: "Montserrat",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "28px",
              }}
            >
              {title}
            </Typography>
            <Box
              component="ul"
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography component="li" sx={PaymentAndBillingSectionListStyle}>
                {list[0]}
              </Typography>
              <Typography component="li" sx={PaymentAndBillingSectionListStyle}>
                {list[1]}
              </Typography>
              <Typography component="li" sx={PaymentAndBillingSectionListStyle}>
                {list[2]}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PaymentAndBilling;
